<template>
  <div>
    <b-container>
      <div v-if="isGlobalApp" class="d-flex justify-content-center mt-2 mb-2">
        <b-img width="150" height="130" :src="require('@base/assets/images/flealover-sitelogo.png')" />
      </div>
      <div v-else class="d-flex justify-content-center">
        <b-img :src="require('@base/assets/images/sitelogo.png')" />
      </div>
      <b-row align-h="between">
        <b-col
          v-if="userMarket && userMarket.mobileAppAccess"
          class="align-self-center"
          cols="12" md="12" sm="12" lg="6"
        >
          <a
            :href="appStoreUrl"
            target="_blank"
            class="ml-3"
          >
            <b-img
              width="200"
              height="100"
              :src="require(`@base/assets/images/badges/download-on-the-app-store-${$_languageCode}.svg`)"
            />
          </a>
          <a
            :href="playMarketUrl"
            target="_blank"
          >
            <b-img
              width="230"
              height="100"
              :src="require(`@base/assets/images/badges/google-play-badge-${$_languageCode}.png`)"
            />
          </a>
        </b-col>
        <b-col
          v-if="userMarket && userMarket.onlineBookingFeature && userMarket.showPaymentTerms && userMarket.elavonApiValid && userMarket.customerAccessToBooking && userMarket.customerAccessToProductCreation && userMarket.individualizedItemsAccess && (userMarket.flexposApiValid || (userMarket.zettleIntegration && userMarket.zettleApiValid))"
          cols="12" md="12" sm="12" lg="6" class="pr-lg-4"
        >
          <b-button
            class="mt-3 mb-3 products-button-float"
            @click="$router.push({name: 'product-sheets'})"
            variant="success">
            {{ $t('navigation.customer.product_sheets') }}
          </b-button>

          <b-button
            class="mt-3 mb-3 products-button-float"
            @click="$router.push({name: 'create-booking'})"
            variant="info">
            {{ $t('navigation.customer.create_new_booking') }}
          </b-button>
        </b-col>
        <b-col
          v-else-if="userMarket && userMarket.customerAccessToProductCreation && userMarket.individualizedItemsAccess && (userMarket.flexposApiValid || (userMarket.zettleIntegration && userMarket.zettleApiValid))"
          cols="12" md="4" sm="12" lg="3"
        >
          <b-button
            class="mt-3 mb-3 products-button"
            @click="$router.push({name: 'product-sheets'})"
            variant="success">
            {{ $t('navigation.customer.product_sheets') }}
          </b-button>
        </b-col>
        <b-col
          v-else-if="userMarket && !userMarket.customerAccessToProductCreation && userMarket.onlineBookingFeature && userMarket.showPaymentTerms && userMarket.elavonApiValid && userMarket.customerAccessToBooking && (userMarket.flexposApiValid || (userMarket.zettleIntegration && userMarket.zettleApiValid))"
          cols="12" md="4" sm="12" lg="3"
        >
          <b-button
            class="mt-3 mb-3 products-button"
            @click="$router.push({name: 'create-booking'})"
            variant="info">
            {{ $t('navigation.customer.create_new_booking') }}
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" sm="12" lg="12">
          <h5
            class="pb-2 ml-3"
            v-html="$t('pages.login.user.download_app_help_text', {
              app_help_link: mobileAppHelpUrl
            })"
          ></h5>
        </b-col>
      </b-row>
      <b-row class="no-margin-left no-margin-right">
        <b-col
          v-if="userMarket && userMarket.marketImages.length"
          class="no-padding-left no-padding-right custom-container-md"
          cols="12" md="12" sm="12" lg="12"
        >
          <image-slider
            :images="userMarket.marketImages"
          />
        </b-col>
      </b-row>
      <b-alert
        class="text-center pre-wrap mt-2"
        show
        variant="info"
        v-if="userMarket && userMarket.extraMarketInfo"
      >
        {{ userMarket.extraMarketInfo }}
      </b-alert>
      <head-block :title="$t('title.customer.sales')" />
      <div v-if="userMarket && customerData">
        <p v-html="$t('pages.sales.user_number', { user_number: customerData.userNumber })"></p>
        <p
          v-if="userMarket.customerAccessToAccountBalance && userMarket.accountBalanceFeature"
          v-html="$t('pages.sales.account_balance', { account_balance: customerData.accountBalance })"
        ></p>
        <p v-html="$t('pages.sales.commission', { fee: customerData.fee, market_name: userMarket.visualName })"></p>
        <div v-if="customerData.campaign && !customerData.campaignRequestName">
          <p v-html="$t('pages.sales.campaign', { campaign_discount: customerData.campaign.discountPercent })"></p>
          <b-button
            class="mb-2"
            variant="danger"
            @click="showConfirmModal(customerData, 'request-campaign-remove')">
            {{ $t('table.product_sheets.button_request_campaign_remove') }}
          </b-button>
        </div>
        <div v-else-if="!customerData.campaign && customerData.campaignRequestName">
          <p v-html="$t('pages.sales.campaign_request_join', { campaign_discount: customerData.campaignRequestDiscount })"></p>
        </div>
        <div v-else-if="customerData.campaign && customerData.campaignRequestName">
          <p v-html="$t('pages.sales.campaign_request_removal', { campaign_discount: customerData.campaignRequestDiscount })"></p>
        </div>
        <div v-else-if="!customerData.campaign && !customerData.campaignRequestName">
          <p v-html="$t('pages.sales.no_active_campaign')"></p>
          <b-button
            class="mb-2"
            variant="info"
            @click="$bvModal.show('request-campaign-add')">
            {{ $t('table.product_sheets.button_request_campaign_add') }}
          </b-button>
        </div>
        <request-campaign-modal
          modalId="request-campaign-add"
          v-if="userMarket && customerData" />
        <confirm-item-modal
          modalId="request-campaign-remove"
          :okButtonTitle="$t('modal.general.ok_button')"
          :cancelButtonTitle="$t('modal.general.cancel_button')"
          :title="$t('modal.product_sheets.title_request_campaign_removal')"
          :text="$t('modal.product_sheets.text_request_campaign_removal')"
          @onConfirm="confirmObjectAction(
            $_actionTypes.REQUEST_PRODUCT_CAMPAIGN_REMOVAL,
            'userNumber',
            $t('notifications.text.product_sheets.success_campaign_removal_requested'),
          )"/>
        <div class="mt-2 mb-2">
          <h5>{{ $t('title.customer.sales_dashboard') }}</h5>
          <content-table
            fixed
            :fields="fields"
            :items="userSaleLineSummary"
            :slots="templates"
            head-variant="dark"
          >
            <template slot="amount" slot-scope="data">
              <div>
                {{ formatNumber(data.tbl.item.amountTotal, { precision: 2, acceptZero: true, marketCountry: userMarket?.supportCountry?.code }) }}
              </div>
            </template>
            <template slot="quantity" slot-scope="data">
              <div>
                {{ formatNumber(data.tbl.item.quantityTotal, { precision: 2, acceptZero: true, marketCountry: userMarket?.supportCountry?.code }) }}
              </div>
            </template>
            <template slot="share" slot-scope="data">
              <div>
                {{ formatNumber(data.tbl.item.shareTotal, { precision: 2, acceptZero: true, marketCountry: userMarket?.supportCountry?.code }) }}
              </div>
            </template>
            <template slot="period" slot-scope="data">
              <div>
                {{ getObjectByKeyValue(salesSummaryPeriods, 'code', data.tbl.item.period).name }}
              </div>
            </template>
          </content-table>
          <span v-if="!loader.isActive && !userSaleLineSummary.length" class="no-table-data mt-5">
            {{ $t('table.general.no_data') }}
          </span>
        </div>

        <h4>{{ $t('title.customer.sale_lines') }}</h4>
        <sales-filter
          class="mb-3"
          @filter-applied="updateSaleLinesWithFilter"
          v-if="Object.keys(customerData).length"
          :start="saleFilters.dateStart"
          :end="saleFilters.dateEnd"/>

        <b-card
          class="mb-3"
          v-for="(saleList, date, index) in userSaleLines"
          :key="date"
          no-body
          header-tag="header"
          footer-class="total-sale-footer-container"
        >
          <template #header>
            <h6 class="mb-0">{{ $t('table.sales.title_date_of_sale', { date: formatDate(date, userMarket?.supportCountry?.code, userMarket?.timezone) }) }}</h6>
          </template>
          <b-list-group flush v-for="(saleLine, key) in saleList" :key="`${key}A`">
            <!--We have to render each sale line by each quantity-->
            <!--We add "|| 1", because return sale lines have 0 quantity, -->
            <!--but we still need to render it-->
            <b-list-group-item class="d-flex justify-content-between" v-for="i in (Math.abs(parseInt(saleLine.quantity)) || 1)" :key="`${i}B`">
              <span v-if="saleLine.product && saleLine.product.name">
                {{ `${saleLine.product.sheetProductId}: ${saleLine.product.name}` }}
                {{ saleLine.displayDiscountPercent ? $t('table.sales.discount_percent_text', { discountPercent: formatNumber(saleLine.displayDiscountPercent, { precision: 1, marketCountry: userMarket?.supportCountry?.code }) }) : '' }}
              </span>
              <span v-else-if="saleLine.product">
                {{ `${saleLine.product.sheetProductId}: ${saleLine.productType === usedProductType ? $t('table.sales.generic_used_product_name') : $t('table.sales.generic_new_product_name')}` }}
                {{ saleLine.displayDiscountPercent ? $t('table.sales.discount_percent_text', { discountPercent: formatNumber(saleLine.displayDiscountPercent, { precision: 1, marketCountry: userMarket?.supportCountry?.code }) }) : '' }}
              </span>
              <span v-else>
                {{ saleLine.productType === usedProductType ? $t('table.sales.generic_used_product_name') : $t('table.sales.generic_new_product_name') }}
                {{ saleLine.displayDiscountPercent ? $t('table.sales.discount_percent_text', { discountPercent: formatNumber(saleLine.displayDiscountPercent, { precision: 1, marketCountry: userMarket?.supportCountry?.code }) }) : '' }}
              </span>
              <span>{{ formatNumber(saleLine.pricePerPiece, { precision: 2, marketCountry: userMarket?.supportCountry?.code }) }}</span>
            </b-list-group-item>
          </b-list-group>
          <template #footer v-if="index === Object.keys(userSaleLines).length - 1">
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between" variant="info">
                <span class="font-weight-bold">{{ $t('table.sales.title_total') }}</span>
                <span>{{ formatNumber(totalSaleAmount, { precision: 2, marketCountry: userMarket?.supportCountry?.code }) }}</span>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between" variant="info">
                <span class="font-weight-bold">{{ $t('table.sales.title_total_share') }}</span>
                <span>{{ formatNumber(totalShareAmount, { precision: 2, marketCountry: userMarket?.supportCountry?.code }) }}</span>
              </b-list-group-item>
            </b-list-group>
          </template>
        </b-card>
        <span v-if="!loader.isActive && !Object.keys(userSaleLines).length" class="no-table-data mb-3">
          {{ $t('table.general.no_data') }}
        </span>
      </div>
      <b-row class="justify-content-center">
        <b-card-group deck class="mt-2 mb-2" v-if="userMarket">
          <b-col cols="12" md="12" sm="12" lg="6">
            <market-contact-info-card
              :market="userMarket"
              :market-feedback="marketFeedback"
            />
          </b-col>
          <b-col cols="12" md="12" sm="12" lg="6">
            <market-opening-hours-card
              :market="userMarket"
            />
          </b-col>
        </b-card-group>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import HeadBlock from '@base/components/HeadBlock.vue'
  import SalesFilter from '@user/components/SalesFilter.vue'
  import ContentTable from '@base/components/ContentTable.vue'
  import ImageSlider from '@base/components/ImageSlider.vue'
  import MarketContactInfoCard from '@base/components/MarketContactInfoCard.vue'
  import MarketOpeningHoursCard from '@base/components/MarketOpeningHoursCard.vue'
  import { mapState } from 'vuex'
  import Formatting from '@base/mixins/Formatting'
  import TableUtils from '@base/mixins/TableUtils'
  import ObjectUtils from '@base/mixins/ObjectUtils.vue'
  import moment from 'moment'
  import {
    customerRequestInterceptor,
    customerResponseFulfilledInterceptor,
    customerResponseRejectedInterceptor
  } from '@base/store'
  import { marketFeedback } from '@base/services'
  import {
    APP_STORE_URL,
    PLAY_MARKET_URL,
    MOBILE_APP_HELP_URLS,
    USED,
    IS_GLOBAL_APP,
  } from '@base/configs'
  import { SALES_SUMMARY_PERIODS } from '@user/configs'
  import ConfirmItemModal from "@base/components/ConfirmItemModal.vue";
  import RequestCampaignModal from "@user/components/RequestCampaignModal.vue";
  import ObjectAction from "@base/mixins/ObjectAction.vue";


  marketFeedback.interceptors.request.use(customerRequestInterceptor)
  marketFeedback.interceptors.response.use(
    customerResponseFulfilledInterceptor,
    customerResponseRejectedInterceptor
  )

  export const defaultSaleFilters = {
    dateStart: moment().startOf('month').format(), // current month is the default range for sales
    dateEnd: moment().endOf('day').format(),
    productType: null,
  }


  export default {
    name: 'SalesView',

    components: {
      RequestCampaignModal,
      ConfirmItemModal,
      HeadBlock,
      ContentTable,
      SalesFilter,
      ImageSlider,
      MarketContactInfoCard,
      MarketOpeningHoursCard,
    },

    mixins: [ Formatting, TableUtils, ObjectAction, ObjectUtils ],

    data () {
      return {
        fields: [
          { key: 'period', label: this.$t('table.sales.period'), class: 'text-left' },
          { key: 'quantityTotal', label: this.$t('table.sales.quantity_total'), class: 'text-right' },
          { key: 'amountTotal', label: this.$t('table.sales.amount_total'), class: 'text-right' },
          { key: 'shareTotal', label: this.$t('table.sales.share'), class: 'text-right' },
        ],
        templates: [
          { name: 'period', field: 'period' },
          { name: 'quantity', field: 'quantityTotal' },
          { name: 'amount', field: 'amountTotal' },
          { name: 'share', field: 'shareTotal' }
        ],
        saleFilters: { ...defaultSaleFilters },
        loader: { isActive: true },
        marketFeedback: marketFeedback,
        appStoreUrl: APP_STORE_URL,
        playMarketUrl: PLAY_MARKET_URL,
        usedProductType: USED,
        salesSummaryPeriods: SALES_SUMMARY_PERIODS,
        isGlobalApp: IS_GLOBAL_APP,
      }
    },

    created() {
      this.getSaleSummary()
      if (Object.keys(this.customerData).length) {
        this.initSales()
      }
      window.addEventListener('resize', this.handleResize)
    },

    watch: {
      // When customer data is loaded, then we apply filters on sale data and collect it
      customerData () {
        this.initSales()
      },
      userMarket () {
        this.setCardFooterStyle()
      }
    },

    computed: {
      ...mapState(['userMarket', 'customerData', 'userSaleLines', 'userSaleLineSummary']),

      mobileAppHelpUrl() {
        return MOBILE_APP_HELP_URLS[this.$i18n.locale.toUpperCase()]
      },

      totalSaleAmount () {
        let totalAmount = 0
        for (const key in this.userSaleLines) {
          totalAmount += this.getTotal(this.userSaleLines[key], 'totalAmount')
        }
        return totalAmount
      },

      totalShareAmount () {
        let totalShare = 0
        for (const key in this.userSaleLines) {
          totalShare += this.getTotal(this.userSaleLines[key], 'share')
        }
        return totalShare
      },
    },

    methods: {
      setDefaultProductType () {
        // If customer has one from two product types - then apply this filter to sales
        if (this.customerData.customerType.length === 1)
          this.saleFilters.productType = this.customerData.customerType[0]
      },

      getSaleLines () {
        return new Promise((resolve) => {
          this.loader = this.$loading.show(this.$_loaderOptions)
          this.$store.dispatch(this.$_actionTypes.GET_SALE_LINES_LIST)
            .catch((error) => {
              this.$_notifyError(error, this)
            })
            .finally(() => {
              this.loader.hide()
              resolve()
            })
        })
      },

      getSaleSummary () {
        return new Promise((resolve) => {
          this.$store.dispatch(this.$_actionTypes.GET_SALE_LINES_SUMMARY)
            .catch((error) => {
              this.$_notifyError(error, this)
            })
            .finally(() => {
              resolve()
            })
        })
      },

      updateSaleLinesWithFilter () {
        this.getSaleLines()
      },

      initSales () {
        this.setDefaultProductType()
        this.$store.commit(this.$_mutationTypes.SET_SALE_LINES_FILTERS, this.saleFilters)
        this.getSaleLines()
      },

      handleResize () {
        this.setCardFooterStyle()
      },

      setCardFooterStyle () {
        this.$nextTick(() => {
          // Define max height of all card footers
          const cardFooterClass = document.getElementsByClassName('card-footer-container')
          const customCardFooterClass = document.getElementsByClassName('custom-card-footer')
          let maxFooterHeight = 0
          for (const elem of customCardFooterClass) {
            if (elem.offsetHeight > maxFooterHeight) {
              maxFooterHeight = elem.offsetHeight
            }
          }

          // Set max height to every footer of card to make it symmetrical
          // and center footer content
          for (const elem of cardFooterClass) {
            elem.style.height = `calc(${maxFooterHeight}px + 1rem)`
            elem.style.display = 'flex'
            elem.style.justifyContent = 'center'
            elem.style.alignItems = 'center'
          }
        })
      },
    }
  }
</script>

<style scoped>

.total-sale-footer-container {
  padding: 0 !important;
}

.products-button {
  padding: 1.2rem 2rem;
  margin-left: 2.5rem;
}

.products-button-float {
  padding: 1.2rem 2rem;
  margin-left: 1rem;
  float: right;
}

@media (max-width: 1200px) {
    .products-button-float {
      padding: 1.2rem 2.55rem;
      margin-left: 1rem;
      float: none;
    }

    .products-button {
      padding: 1.2rem 2rem;
      margin-left: 1rem;
    }
}

@media (max-width: 767px) {
  .products-button {
    padding: 1.2rem 2rem;
    margin-left: 1rem;
  }
}

</style>
